export default __webpack_public_path__ + "static/media/arrows-refresh-2847.5fa09292.svg";